export const APPS = {
   api: 'api',
   crm: 'crm',
   crmcli: 'crmcli',
   dscloud: 'dscloud',
   key: 'key',
   manager: 'manager',
   publick_tools: 'ptools'
};
export const SCOPES = {
   OPEN_ID: 'openid',
   PROFILE: 'profile',
   EMAIL: 'email',
   //puede ser app.<producto>.<modulo>
   //si es unicamente app, solo funciona con el manager
   APP_INFO: 'app'
};
